import { BillableServiceUIModel } from "@/Administration/Models/UI/BillableService/BillableServiceUIModel";
import { BillableServiceEditMode } from "@/Administration/Models/UI/Enums/Administration";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { PrivateBillCostCenter } from "@/Common/Components/Billing/PrivateBillCostCenter";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { Combobox, ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { EnvironmentTax } from "@/Common/Helpers/EnvironmentTax";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import * as LocalOperations from "@/Common/Operations/operations.local";

interface IEditBillableServiceComponentProps {
    currentEditMode: BillableServiceEditMode;
    editedBillableService: BillableServiceUIModel;
    onCloseOperation: number;
}

class EditBillableServiceComponentState {
    public editedBillableService: BillableServiceUIModel;
}

class EditBillableServiceComponent extends BaseReactComponent<IEditBillableServiceComponentProps, EditBillableServiceComponentState> {
    private id = "billableServiceEditComponent";

    public constructor(props: IEditBillableServiceComponentProps) {
        super(props);
        this.state = {
            editedBillableService: props.editedBillableService
        };
    }

    public componentDidMount(): void {
        this.setOverlay("EditBillableServiceComponent", { transparent: false });
        let elem = $(`#${this.id}`);
        let cnt = document.body;
        let dragOptions = {
            containment: cnt,
            handle: ".p-header",
            stop: () => {
                elem.draggable("destroy");
                window.setTimeout(() => {
                    elem.draggable(dragOptions);
                }, 80);
            }
        };

        elem.draggable(dragOptions);
    }

    public render(): JSX.Element {
        let self = this;
        let isFormValid = this.isValid();
        // let sites = BillableServiceUIModel.getAllSitesExistInCostCenter();
        let sites = cacheStore.SiteCache;
        let sitesComboBox: Immutable.List<ComboBoxDropDownItem> = Immutable.List(sites.map(x => SitesModel.ToComboboxItem(x)));
        let costCenterComboBox: Immutable.List<ComboBoxDropDownItem> = Immutable.List(cacheStore.CostCenterCache.map(x => PrivateBillCostCenter.ToComboboxItem(x)));

        let centers = this.state.editedBillableService.getCostCentersBySiteId();
        if (centers && centers.length > 0)
            costCenterComboBox = Immutable.List(centers.map(x => PrivateBillCostCenter.ToComboboxItem(x)));
        else costCenterComboBox = Immutable.List([]);

        // get proper title
        let title: string = "";
        if (self.props.currentEditMode == BillableServiceEditMode.Edit)
            title = cacheStore.GetString("EditServiceLabel");
        else
            title = cacheStore.GetString("AddServiceLabel");

        return (
            <div className="request-popup popup-billable-services" id={this.id}>
                <div className="p-header ui-draggable-handle">
                    <a className="close" onClick={() => sessionStore.dispatch(self.props.onCloseOperation)}>x</a>
                    <h3 className="uppercase">{title}</h3>
                </div>
                <div className="p-body">
                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divlabel"><label className="no-margin">{cacheStore.GetString("NameEnLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <TextboxControl
                                debounceMs={200}
                                value={this.state.editedBillableService.Model.NameEn}
                                onChange={(value: string) => this.mutateState(s => {
                                    s.editedBillableService = this.state.editedBillableService;
                                    s.editedBillableService.Model.NameEn = value;
                                })}
                                style={{ marginRight: "10px" }}
                                className="form-control"
                                placeholder=""
                                id="txtNameEN"
                                valid={BillableServiceUIModel.isEnNameValid(this.state.editedBillableService.Model)}
                            />
                        </div>
                    </div>
                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divlabel"><label className="no-margin">{cacheStore.GetString("NameFrLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <TextboxControl
                                debounceMs={200}
                                value={this.state.editedBillableService.Model.NameFr}
                                onChange={(value: string) => this.mutateState(s => {
                                    s.editedBillableService = this.state.editedBillableService;
                                    s.editedBillableService.Model.NameFr = value;
                                })}
                                style={{ marginRight: "10px" }}
                                className="form-control"
                                placeholder=""
                                id="txtNameEN"
                                valid={BillableServiceUIModel.isFrNameValid(this.state.editedBillableService.Model)}
                            />
                        </div>
                    </div>
                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divlabel"><label className="no-margin">{cacheStore.GetString("NameEsLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <TextboxControl
                                debounceMs={200}
                                value={this.state.editedBillableService.Model.NameEs}
                                onChange={(value: string) => this.mutateState(s => {
                                    s.editedBillableService = this.state.editedBillableService;
                                    s.editedBillableService.Model.NameEs = value;
                                })}
                                style={{ marginRight: "10px" }}
                                className="form-control"
                                placeholder=""
                                id="txtNameEN"
                                valid={BillableServiceUIModel.isEsNameValid(this.state.editedBillableService.Model)}
                            />
                        </div>
                    </div>

                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divlabel"><label className="no-margin">{cacheStore.GetString("NumberPhoneLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <TextboxControl
                                debounceMs={200}
                                value={this.state.editedBillableService.Model.Number}
                                onChange={(value: string) => this.mutateState(s => {
                                    s.editedBillableService = this.state.editedBillableService;
                                    s.editedBillableService.Model.Number = value;
                                })}
                                style={{ marginRight: "10px" }}
                                className="form-control"
                                placeholder=""
                                id="txtNameEN"
                                valid={BillableServiceUIModel.isNumberValid(this.state.editedBillableService.Model)}
                            />
                        </div>
                    </div>

                    {sitesComboBox.count() > 0 && (
                        <div className="popup-services-flex bottom-5">
                            <div className="service-left-label-col">
                                <div className="divlabel"><label className="no-margin">{cacheStore.GetString("SiteDLabel")}</label></div>
                            </div>
                            <div className="service-right-col">
                                <Combobox
                                    HasEmptyItem={true}
                                    id="_SiteComboBox"
                                    items={sitesComboBox}
                                    selectedCode={this.state.editedBillableService.Model.SiteId}
                                    doInitialChangeOp={false}
                                    onChange={(selectedId: string) => {
                                        this.mutateState(s => {
                                            s.editedBillableService = this.state.editedBillableService;
                                            s.editedBillableService.SiteId = selectedId;
                                            s.editedBillableService.getFormatedTaxes(s.editedBillableService);
                                            s.editedBillableService.Model.HasHST = false;
                                            s.editedBillableService.Model.HasGST = false;
                                            s.editedBillableService.Model.HasQST = false;
                                            s.editedBillableService.Model.HasGenericTax = false;
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    {costCenterComboBox.count() > 0 && (
                        <div className="popup-services-flex bottom-5">
                            <div className="service-left-label-col">
                                <div className="divlabel"><label className="no-margin">{cacheStore.GetString("CostCenterLabel")}</label></div>
                            </div>
                            <div className="service-right-col">
                                <Combobox
                                    HasEmptyItem={true}
                                    id="_CostCenterComboBox"
                                    items={costCenterComboBox}
                                    selectedCode={this.state.editedBillableService.Model.CostCenterId}
                                    onChange={(selectedId: string) => {
                                        this.mutateState(s => {
                                            s.editedBillableService = this.state.editedBillableService;
                                            s.editedBillableService.Model.CostCenterId = selectedId;
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divlabel"><label className="no-margin">{cacheStore.GetString("UnitPriceAdminLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <div>
                                <TextboxControl
                                    debounceMs={200}
                                    value={this.state.editedBillableService.Price != null ? this.state.editedBillableService.Price.toString() : ""}
                                    onChange={(value: number) => {
                                        this.mutateState(s => {
                                            s.editedBillableService = this.state.editedBillableService;
                                            s.editedBillableService.Model.Price = value;
                                        });
                                    }}
                                    className="form-control push-right-10"
                                    placeholder=""
                                    id="txtPrice1"
                                    valid={true}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divlabel"><label className="no-margin">{cacheStore.GetString("TaxesLabel")}</label></div>
                        </div>
                        {this.renderTaxSection()}
                    </div>
                </div>

                <div className="p-footer margin-xs-top">
                    <div className="popup-services space-between">
                        <div className="popup-services-flex flex-end ">
                            <ButtonGroup spacing="sm">
                                <ButtonControl
                                    className="btn btn-default"
                                    onClick={() => sessionStore.dispatch(self.props.onCloseOperation)}
                                    label={cacheStore.GetString("CancelLabel")}
                                />
                                <ButtonControl
                                    variant="brand"
                                    onClick={() => this.onSave()}
                                    disabled={isFormValid}
                                    label={cacheStore.GetString("SaveLabel")}
                                />
                            </ButtonGroup>
                        </div>
                    </div>
                </div>

            </div>
        );
    }

    private renderTaxSection(): JSX.Element {
        if (this.state.editedBillableService?.Model?.SiteId)
            return this.renderTaxSectionOnSelectedSite();

        return this.renderTaxSectionOnEnvironment();
    }

    private renderTaxSectionOnSelectedSite(): JSX.Element {
        const selectedSite = cacheStore.GetSiteById(this.state.editedBillableService?.Model?.SiteId);

        return (
            <div className="flex-container">
                {selectedSite.isHst() && this.renderHstCheckbox()}
                {selectedSite.isGst() && this.renderGstCheckbox()}
                {selectedSite.isPstOrQst() && this.renderPstQstCheckbox()}
                {!selectedSite.isCanadaSite() && this.renderGenericTaxCheckbox()}
            </div>
        );
    }

    private renderTaxSectionOnEnvironment(): JSX.Element {
        return (
            <div className="flex-container">
                {EnvironmentTax.hasHst() && this.renderHstCheckbox()}
                {EnvironmentTax.hasGst() && this.renderGstCheckbox()}
                {EnvironmentTax.hasPstOrQst() && this.renderPstQstCheckbox()}
                {EnvironmentTax.hasGenericTax() && this.renderGenericTaxCheckbox()}
            </div>
        );
    }

    private renderHstCheckbox(): JSX.Element {
        return (
            <div className="margin-sm-left">
                <CheckboxControl
                    label={this.state.editedBillableService.labelHST}
                    checked={this.state.editedBillableService.Model.HasHST}
                    onChange={(isChecked: boolean) => this.mutateState(s => {
                        s.editedBillableService = this.state.editedBillableService;
                        s.editedBillableService.Model.HasHST = isChecked;
                    })}
                />
            </div>
        );
    }

    private renderPstQstCheckbox(): JSX.Element {
        return (
            <div className="margin-sm-left">
                <CheckboxControl
                    label={this.state.editedBillableService.labelQST}
                    checked={this.state.editedBillableService.Model.HasQST}
                    onChange={(isChecked: boolean) => this.mutateState(s => {
                        s.editedBillableService = this.state.editedBillableService;
                        s.editedBillableService.Model.HasQST = isChecked;
                    })}
                />
            </div>
        );
    }

    private renderGstCheckbox(): JSX.Element {
        return (
            <div className="margin-sm-left">
                <CheckboxControl
                    label={this.state.editedBillableService.labelGST}
                    checked={this.state.editedBillableService.Model.HasGST}
                    onChange={(isChecked: boolean) => this.mutateState(s => {
                        s.editedBillableService = this.state.editedBillableService;
                        s.editedBillableService.Model.HasGST = isChecked;
                    })}
                />
            </div>
        );
    }

    private renderGenericTaxCheckbox(): JSX.Element {
        return (
            <div className="margin-sm-left">
                <CheckboxControl
                    label={this.state.editedBillableService.labelGenericLabel}
                    checked={this.state.editedBillableService.Model.HasGenericTax}
                    onChange={(isChecked: boolean) => this.mutateState(s => {
                        s.editedBillableService = this.state.editedBillableService;
                        s.editedBillableService.Model.HasGenericTax = isChecked;
                    })}
                />
            </div>
        );
    }

    private isValid(): boolean {
        let result = true;
        if (this.state.editedBillableService.Model == null) return true;

        result = IsNullOrWhiteSpace(this.state.editedBillableService.Model.NameEs) ||
            IsNullOrWhiteSpace(this.state.editedBillableService.Model.NameFr) ||
            IsNullOrWhiteSpace(this.state.editedBillableService.Model.NameEn) ||
            IsNullOrWhiteSpace(this.state.editedBillableService.Model.Number);

        return result;
    }

    private onSave(): void {
        sessionStore.dispatch(LocalOperations.AdministrationBillableService.BillableServiceEdit_Save, { Service: this.state.editedBillableService.Model });
    }
}

export { EditBillableServiceComponent };
